<template>
    <section class="_modal_wrapper" @touchmove.stop>
        <div class="_modal">
            <!-- 领取成功 -->
            <div class="_modal_box" v-if="modalType === 1">
                <div class="_modal_box_icon" />
                <p class="_title">领取成功</p>
                <p class="_title">请下载才博APP收听</p>
                <div class="_modal_box_buttons mt86">
                    <div class="_disable" @click="$emit('close')">取消</div>
                    <div @click="$emit('download')">去下载</div>
                </div>
            </div>
            <!-- app内免费阅读 -->
            <div class="_modal_box" v-if="modalType === 2">
                <div class="_modal_box_icon" />
                <p class="_title">你的听书成功领取</p>
                <p>请在才博APP下方的已购专区进行收听</p>
                <div class="_modal_box_buttons">
                    <div @click="$emit('close')">知道了</div>
                </div>
            </div>
            <!-- 领取失败 -->
            <div class="_modal_box" v-if="modalType === 3">
                <div class="_modal_box_icon gray" />
                <p class="_title">领取失败</p>
                <p>{{des}}</p>
                <div class="_modal_box_buttons">
                    <div @click="$emit('close')">知道了</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'Modal',
        props: {
            /**
             * 区分弹窗展示类型
             */
            modalType: {
                type: Number
            },
            des: {
                type: String
            }
        } 
    }
</script>

<style lang="scss" scoped>
    @import '../../style/main';

    ._modal_wrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999999;
        background-color: rgba(#000, .6);
    }

    ._modal {
        transform: translate(-50%, -50%);
        position: absolute;
        top: 50%;
        left: 50%;
        width: rem(530);
        border-radius: rem(10);
        background-color: #fff;
        text-align: center;

        &_box {
            padding: rem(60) rem(35);
            
            &_icon {
                $size: rem(100);
                margin: 0 auto rem(50);
                width: $size;
                height: $size;
                border-radius: 50%;
                background: url('./images/icon_green.png') no-repeat;
                background-size: cover;

                &.gray {
                    background: url('./images/icon_gray.png') no-repeat;
                    background-size: cover;
                }
            }

            > p {
                margin: 0 auto;
                width: rem(360);
                line-height: 1.5;
                font-size: rem(28);
                color: #999;
                
                &._title {
                    font-weight: bold;
                    font-size: rem(36);
                    color: #333;
                }
            }

            &_buttons {
                margin-top: rem(60);

                &.mt86 {
                    margin-top: rem(86);
                }
                
                > div {
                    display: inline-block;
                    padding: rem(20) 0;
                    width: rem(220);
                    border-radius: rem(8);
                    background-image: linear-gradient(to right, #fe8c43, #ff7253);
                    font-weight: bold;
                    font-size: rem(36);
                    color: #fff;

                    &._disable {
                        background: #cecece;
                    }

                    &:nth-child(2) {
                        margin-left: rem(20);
                    }

                    &:only-child {
                        width: rem(300);
                    }
                }
            }
        }
    }
</style>
